export { default } from './Collapse';


//////////////////
// WEBPACK FOOTER
// ../~/@material-ui/core/esm/Collapse/index.js
// module id = 224
// module chunks = 121